import Service from '@/service/index.js';
import { mapGetters } from 'vuex';
import synthesizeFormMixins from '../mixins/synthesize-form.js';
export default {
  mixins: [synthesizeFormMixins],
  props: ['projectInfo', 'projectSubType'],
  data() {
    return {
      bidGeneralSituation: 2, // 四荒使用权
      typeArr: [],
      massifs: [
        {
          massifName: '',
          area: null,
          type: '',
          price: null,
          toEast: '',
          toWest: '',
          toSouth: '',
          toNorth: '',
          attachment: ''
        }
      ],
      rules: {
        massifName: [
          { required: true, message: '请输入地块名称', trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请输入地块面积', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择地块类型', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入地块转让总价格', trigger: 'blur' }
        ],
        toEast: [
          { required: true, message: '请输入东至', trigger: 'blur' }
        ],
        toWest: [
          { required: true, message: '请输入西至', trigger: 'blur' }
        ],
        toSouth: [
          { required: true, message: '请输入南至', trigger: 'blur' }
        ],
        toNorth: [
          { required: true, message: '请输入北至', trigger: 'blur' }
        ],
        attachment: [
          { required: true, message: '请输入地上附着物', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      'tradeType',
      'transferType'
    ])
  },
  created () {
    Service.getSelectList('SIHUANG_TYPE').then(res => {
      if (res && res.code === '0') {
        this.typeArr = res.data;
      }
    });
  },
  methods: {
    priceVali(rule, value, callback){
      if(value === '' || value === null){
        callback(new Error('请输入地块价格'));
      } else if(value < 1 || value > 9999999.99){
        callback(new Error('请输入0-10000000以内的数字'));
      } else {
        callback();
      }
    },
    areaVali(rule, value, callback){
      console.log(value, 'value');
      if(value === '' || value === null){
        callback(new Error('请输入地块面积'));
      } else if(value < 1 || value > 99999.99){
        callback(new Error('请输入0-100000以内的数字'));
      } else {
        callback();
      }
    },
    // 当从别的页面切换过来时候 清空当前页面的值 如果说默认要展示当前页面 则不清空
    clear(){
      if( this.projectInfo.projectType === 1) return false;
      this.massifs = [
        {
          massifName: '',
          area: null,
          type: this.projectSubType,
          price: null,
          toEast: '',
          toWest: '',
          toSouth: '',
          toNorth: '',
          attachment: ''
        }
      ];
      this.totalForm = {
        sumArea: null
      };
      // 清空红色必填标示
      if(this.$refs['sihuangForm']) {
        this.$refs['sihuangForm'].resetFields();
      }
    },
    addLand () {
      this.massifs.push({
        massifName: '',
        area: null,
        type: this.projectSubType,
        price: null,
        toEast: '',
        toWest: '',
        toSouth: '',
        toNorth: '',
        attachment: ''
      });
    },
    deleteLand (index) {
      this.massifs.splice(index, 1);
      let sumArea = 0;
      this.massifs.forEach(item => {
        sumArea += Number(item.area);
      });
      this.totalForm.sumArea = sumArea.toFixed(2);

      // let sumPrice = null;
      // this.massifs.forEach(item => {
      //   sumPrice += Number(item.price);
      // });
      // this.totalForm.sumPrice = sumPrice.toFixed(2);
      this.$emit('landTotalForm', { count: this.massifs.length});
    }
    // test() {
    //   // console.log(this.massifs, 'this.massifs');

    //   return new Promise((resolve, reject) => {
    //     let num = 0;
    //     this.massifs.forEach((form, index) => {
    //       form.price = 0;
    //       this.$refs[`sihuangForm${index}`][0].validate((valid) => {
    //         if (valid) {
    //           num ++;
    //         } else {
    //           reject();
    //         }
    //       });
    //     });
    //     if (num === this.massifs.length) {
    //       resolve({
    //         massifs: JSON.parse(JSON.stringify(this.massifs)),
    //         ...this.totalForm,
    //         bidGeneralSituation: this.bidGeneralSituation
    //       });
    //     } else {
    //       reject();
    //     }
    //   });
    // }
  }
};
